<template>
  <div class="card-body">
    <div class="brand-wrapper">
      <img src="@/assets/images/logo.svg"
        alt="logo"
        class="logo">
    </div>
    <p class="login-card-description">Aanmelden <small>met QR</small></p>
    <scanner></scanner>
    <router-link
        :to="{name: 'choose'}"
      class="forgot-password-link">
      <span class="mdi mdi-arrow-left"></span> Andere methode
    </router-link>
  </div>
</template>

<script>
import scanner from '@/views/scanner.vue';

export default {
  name: 'login',
  components: {
    scanner,
  },
};
</script>

<style lang="scss">
</style>
